<template>
  <div>
    <div class="p_c" v-show="isShow">
      <img src="@/assets/img/delete.png" alt="" @click="deleteImg" class="deleteImg">
      <img src="@/assets/img/wymf.gif" alt="" @click="jumpHtml" class="mainImg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'slideImg',
  data() {
    return {
      isShow: true
    }
  },
  mounted() {

  },
  methods: {
    jumpHtml() {
      this.$router.push({
        path: "/buyHouse",
      });
    },
    deleteImg() {
      this.isShow = false
    }
  }
}
</script>

<style lang="less">
.p_c{
  position: fixed;
  right:1%;
  top:55%;
  .deleteImg{
    width: 15px;
    height:15px;
    position: absolute;
    right: 0;
    top:0;
  }
  .mainImg{
    width: 90px;
    height:90px
  }
}
</style> 